/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventpublicwithinviteshint4Inputs */

const en_eventpublicwithinviteshint4 = /** @type {(inputs: Eventpublicwithinviteshint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These options are already on although the event is public. They stay until you change the visibility.`)
};

const de_eventpublicwithinviteshint4 = /** @type {(inputs: Eventpublicwithinviteshint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Optionen sind schon aktiv, obwohl das Event öffentlich ist. Sie bleiben so, bis du die Sichtbarkeit änderst.`)
};

/**
* | output |
* | --- |
* | "These options are already on although the event is public. They stay until you change the visibility." |
*
* @param {Eventpublicwithinviteshint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventpublicwithinviteshint4 = /** @type {((inputs?: Eventpublicwithinviteshint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventpublicwithinviteshint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventpublicwithinviteshint4(inputs)
	return de_eventpublicwithinviteshint4(inputs)
});
export { eventpublicwithinviteshint4 as "eventPublicWithInvitesHint" }